var DatePicker = function() {
    var appendLeadZeroes = function(n) {
        if (n < 10) {
            return '0' + n;
        }
        return n;
    };
    var datepicker_toggled = new Date().getTime();
    var datepicker_visible = false;

    return {
        init: function() {
            $.fn.datepicker.dates['el'] = {
                days: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
                daysShort: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
                daysMin: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'],
                months: [
                    'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος',
                    'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
                ],
                monthsShort: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μάι', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
                today: 'Σήμερα',
                clear: 'Καθαρισμός',
                weekStart: 1
            };
        },
        bind: function() {
            $('#currday').datepicker({
                orientation: 'left',
                format: 'dd/mm',
                todayHighlight: true,
                todayBtn: 'linked',
                language: 'el',
                disableTouchKeyboard: true,
                maxViewMode: 2,
                forceParse: false
            });
            $('#currday').on('changeDate', function() {
                var date = DatePicker.formatDate($('#currday').datepicker('getDate'));
                if (typeof DesktopHomepage == 'undefined' || !DesktopHomepage.ticker) {
                    var qParams = Generic.setParam('date', date);
                    top.location.href = top.location.pathname + qParams;
                } else {
                    location.href = '/ticker_minisite_show.php?navigation=yes&date=' + date;
                }
            });
            // close datepicker on text input click
            $('#currday').on('click', function() {
                if (new Date().getTime() - datepicker_toggled < 200) {
                    return;
                }
                if ($('div.datepicker').is(':visible')) {
                    $('#currday').datepicker('hide');
                } else {
                    $('#currday').datepicker('show');
                }
            });
            $('#currday').on('show', function(e) {
                if (datepicker_visible) {
                    return;
                }
                datepicker_toggled = new Date().getTime();
                datepicker_visible = true;
            });
            $('#currday').on('hide', function(e) {
                datepicker_visible = false;
                datepicker_toggled = new Date().getTime();
            });
        },
        formatDate: function(date) {
            return date.getFullYear() + '-' + (appendLeadZeroes(date.getMonth() + 1)) + '-' + appendLeadZeroes(date.getDate());
        }
    };
}();
